import { CABANAS } from "@/data/cabanas";
import CabanaCard from "./CabanaCard";

export const CabanasList = () => {
  return (
    <section
      id="cabanas"
      data-testid="cabanas-section"
      className="bg-[#F9F6F0] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-16 lg:mb-20">
          <span className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[#5C6661] font-bold mb-6">
            <span className="w-8 h-px bg-[#2C5545]" />
            Nossas seis cabanas
          </span>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-[#1A2421] tracking-tighter leading-[1.02]">
            Escolha o seu refúgio<br />na natureza.
          </h2>
          <p className="mt-6 text-lg text-[#5C6661] leading-relaxed max-w-2xl">
            Cada cabana tem sua personalidade — do glamping geodésico ao chalé
            de madeira. Todas com parrilla argentina, hidromassagem, café da
            manhã e jantar inclusos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {CABANAS.map((c, i) => (
            <CabanaCard key={c.id} cabana={c} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CabanasList;
